var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.nextEvents)?_c('div',[(_vm.data.nextEvents.length > 0)?_c('div',_vm._l((_vm.data.nextEvents.split(',')),function(item,idx){return _c('b-button',{key:idx,staticClass:"m-1",attrs:{"size":"sm","variant":(item == 'Reject' || item.indexOf('<') > -1)? 'warning' :'success'},on:{"click":function($event){_vm.submitted = true;
              _vm.callWf(
                  {event:item,

                  row:_vm.data.rowKey,
                  workflow:_vm.workflow}
                  )}}},[_vm._v(_vm._s(item.replace('<', '')))])}),1):_vm._e()]):_c('div',[_c('b-button',{staticClass:"m-1",attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.submitted = true;
              _vm.callWf(
                {
                row:_vm.data.rowKey,
                workflow:_vm.workflow
                }

                )}}},[_vm._v(_vm._s(_vm.firstStep))])],1)}
var staticRenderFns = []
export { render, staticRenderFns }